

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { ExpenseCategorySetup } from "../../components/ExpenseCategorySetup";


export const ExpenseCategorySetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Expense Category Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Expense Category", navigateTo: "/company/expense-category/list" },
        { text: "Create Expense Category", navigateTo: "/company/expense-category/setup" }
      ]}
      mainContents={<ExpenseCategorySetup />}
    />
  );
};
